import React, { useLayoutEffect, useRef, useEffect, useState } from 'react';
export const Collapse = function ({ children, className, transition = 'height 250ms ease-out', isOpen, onMouseEnter, onMouseLeave, }) {
    const initialState = { height: '0px', transition };
    const wrapRef = useRef(null);
    const [style, setStyle] = useState(initialState);
    useEffect(function () {
        setStyle((style) => (Object.assign(Object.assign({}, style), { transition })));
    }, [transition]);
    function open() {
        if (!wrapRef.current) {
            return;
        }
        setStyle((style) => {
            var _a;
            return (Object.assign(Object.assign({}, style), { height: ((_a = wrapRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) + 'px' }));
        });
    }
    function close() {
        if (!wrapRef.current) {
            return;
        }
        setStyle((style) => (Object.assign(Object.assign({}, style), { height: '0px' })));
    }
    useLayoutEffect(() => {
        if (isOpen) {
            open();
        }
        else {
            close();
        }
    }, [isOpen]);
    return (React.createElement("div", { ref: wrapRef, className: 'react-collapse ' + className, style: Object.assign({ overflow: 'hidden' }, style), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children));
};
//# sourceMappingURL=Collapse.js.map